/* eslint-disable no-magic-numbers */

import {
	aspectRatios,
	dimensions,
	filesize
} from "widgets/forms/validators/Assets";
import { requiredAsset, validateUnlessExternalRender } from "social/validators/validators";
import {
	isURL,
	maxLength,
	requiredNotNull
} from "widgets/forms/validators/validators";
import { uniquePACVariableName } from "widgets/social2/validators/utils";

import { MAX_IMAGE_BYTES } from "./consts";

export const staticValidators = {
	image: [uniquePACVariableName],
	primaryText: [uniquePACVariableName],
	landingPage: [uniquePACVariableName],
};

export const validators = {
	image: validateUnlessExternalRender([
		requiredAsset,
		filesize({ max: MAX_IMAGE_BYTES }),
		dimensions({ minWidth: 600, minHeight: 600 }),
		aspectRatios([{ width: 9, height: 16 }], 0.03),
	]),
	primaryText: [
		maxLength(2200),
	],
	landingPage: [
		requiredNotNull,
		isURL,
	],
};
